// @flow
import React, { useState, useEffect } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { Tr, TdLabel } from 'app/common/ui-components/table';
import PlainRadioButton from 'app/common/ui-next/plain-radio-button';
import { DotsLoader } from 'app/common/components/Loader';
import Picture from 'app/common/ui-next/picture';

import styles from './TargetSelectModalItem.module.scss';;


export type EmployeeInfo = {
  id: number,
  photoUrl: ?string,
  postTitle: ?string,
}

export type StudentInfo = {
  id: number,
  photoUrl: ?string,
  classTitle: ?string,
}

type Props = {
  t: (s: string) => string,
  type: 'Student' | 'Employee' | 'Parent' | string,
  id: number,
  name: string,
  currentTargetId: number,
  onClickTarget: (e: SyntheticEvent<HTMLInputElement>) => void,
  onRequestEmployee?: (id: number) => Promise<EmployeeInfo>,
  onRequestStudent?: (id: number) => Promise<StudentInfo>,
};

const TargetSelectModalItem = ({
  t,
  type,
  id,
  name,
  currentTargetId,
  onClickTarget,
  onRequestEmployee,
  onRequestStudent,
}: Props) => {
  const htmlFor = `id_${id}`;

  const [info, setInfo] = useState('');
  const [photo, setPhoto] = useState('');
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    (async () => {
      if (!requested && visible) {
        if (onRequestEmployee && type === 'Employee') {
          const { postTitle, photoUrl } = await onRequestEmployee(id);
          setInfo(postTitle);
          setPhoto(photoUrl || '');
        }
        if (onRequestStudent && type === 'Student') {
          const { classTitle, photoUrl } = await onRequestStudent(id);
          setInfo(classTitle);
          setPhoto(photoUrl || '');
        }
        setLoading(false);
        setRequested(true);
      }
    })();
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <VisibilitySensor onChange={setVisible} partialVisibility delayedCall>
      <Tr key={id}>
        <TdLabel htmlFor={htmlFor} className={styles.td}>
          <PlainRadioButton
            id={htmlFor}
            label={name}
            hideLabel
            name="product"
            value={String(id)}
            onChange={onClickTarget}
            checked={currentTargetId === id}
          />
        </TdLabel>
        <TdLabel htmlFor={htmlFor} className={styles.td}>
          {photo
            && <Picture
              alt={name}
              src={photo}
              height="80px"
              width="80px"
            />}
        </TdLabel>
        <TdLabel htmlFor={htmlFor} className={styles.td}>
          <div>{name}</div>
          <div className={styles.info}>
            {loading && <DotsLoader simple />}
            {!loading
              && type !== 'Student'
              && type !== 'Employee'
              && t('target_select_info_parent')}
            {!loading && info}
          </div>
        </TdLabel>
      </Tr>
    </VisibilitySensor>
  );
};

export default TargetSelectModalItem;
